const baseColors = {
  // Primary colors - Modern AI palette
  primaryPurple: '#7C3AED', // Primary purple
  primaryBlue: '#1E40AF', // Deep blue for gradients
  secondaryLavender: '#A78BFA', // Soft lavender

  // Accent colors
  accentMint: '#34D399', // Mint green accent
  accentYellow: '#FBBF24', // Bright yellow accent
  accentOrange: '#F97316', // High-contrast orange
  accentGreen: '#10B981', // High-contrast green

  // Background colors
  bgWhite: '#FFFFFF',
  bgLight: '#F8FAFC',
  bgLavender: '#E0E7FF',

  // Text colors
  textPrimary: '#1F2937',
  textSecondary: '#374151', // Darker for better contrast

  // Additional colors
  charcoal: '#0F172A', // Deep dark blue-gray
  slate: '#1E293B', // Softer dark
  gray: '#64748B', // Mid-tone gray
  lightGray: '#E2E8F0', // Light background
  white: '#FFFFFF',
};

const functionalColors = {
  bodyBg: baseColors.bgLight,
  border: baseColors.lightGray,
  colorTextBody: baseColors.textPrimary,
  colorHeadings: baseColors.textPrimary,
  main: baseColors.primaryPurple,
  secondary: baseColors.secondaryLavender,
  accent: baseColors.accentMint,
  accentAlt: baseColors.accentYellow,
  ctaPrimary: baseColors.accentOrange,
  ctaSecondary: baseColors.accentGreen,
  muted: baseColors.textSecondary,
  success: baseColors.accentMint,
  warning: baseColors.accentYellow,
  info: baseColors.primaryBlue,
  gradientStart: baseColors.primaryPurple,
  gradientEnd: baseColors.primaryBlue,
};

const colors = { ...baseColors, ...functionalColors };

export default colors;
